export const SECTION_SLUG = "EssentialElements\\Section";
export const POPUP_SLUG = "EssentialElements\\Popup";
export const COLUMNS_SLUG = "EssentialElements\\Columns";
export const COLUMN_SLUG = "EssentialElements\\Column";
export const DIV_SLUG = "EssentialElements\\Div";
export const MISSING_ELEMENT_SLUG = "EssentialElements\\MissingElement";
export const GLOBAL_BLOCK_SLUG = "EssentialElements\\Globalblock";
export const RICH_TEXT_SLUG = "EssentialElements\\RichText";

export const spacingBarsPresetSlug = [
  "spacing_all_y",
  "spacing_all_x",
  "spacing_all",
  "spacing_all_not_responsive",
  "spacing_margin_all",
  "spacing_margin_y",
  "spacing_margin_x",
  "spacing_padding_all",
  "spacing_padding_y",
  "spacing_padding_x"
] as const;

export type SpacingBarSlugs = (typeof spacingBarsPresetSlug)[number];
